export const SETTLEMENT_LIST = 'SETTLEMENT_LIST';
export const SETTLEMENT_DROPDOWN = 'SETTLEMENT_DROPDOWN';
export const SETTLEMENT_BALANCE = 'SETTLEMENT_BALANCE';
export const SETTLEMENT_CREATE = 'SETTLEMENT_CREATE';